import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si estoy embarazada o mi bebé tiene pocos días?',
  a: 'Sí. El pack te acompaña desde el primer enganche, con información clara para los primeros días y herramientas para cada etapa de la lactancia.'
}, {
  q: '¿Sirve si ya llevo semanas con dolor?',
  a: 'Sí. El dolor tiene causas concretas y el pack reúne protocolos para identificar qué observar y cómo actuar en cada toma.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Es 100% digital. Después del pago recibís el acceso por email para descargar los tomos y bonos en pocos minutos.'
}, {
  q: '¿Qué lo diferencia de los consejos de Instagram?',
  a: 'No son consejos sueltos: vas a encontrar secuencias, señales visuales, trackers y herramientas prácticas adaptadas al contexto argentino.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'El material es descargable. Una vez que lo recibís, queda disponible para que vuelvas a consultarlo cuando lo necesites.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días para revisar el contenido. Si sentís que no es para vos, escribinos a soporte.mamasinkos@gmail.com y gestionamos la devolución.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-cream-light px-4 py-16 md:py-20" data-id="element-119" data-mp="11w7e56rapvya">
      <div className="mx-auto max-w-3xl" data-id="element-120" data-mp="16np8vd2q70at">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-121" data-mp="16piecp1lreh8">
          <p className="text-sm font-bold tracking-[0.14em] text-brand-accent uppercase" data-id="element-122" data-mp="wyxk1dsyow44">Resolvé tus dudas</p>
          <h2 className="mt-3 font-serif text-4xl text-brand-darker md:text-5xl" data-id="element-123" data-mp="iywidw4vhknl">Preguntas frecuentes</h2>
        </motion.div>

        <div className="space-y-3" data-id="element-124" data-mp="n1st70o68cgz">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.article key={faq.q} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="overflow-hidden rounded-2xl border border-brand-primary/35 bg-brand-cream shadow-sm" data-id="element-125" data-mp="2kuvmg9bkmwl3" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left transition-colors hover:bg-brand-primary/10" aria-expanded={isOpen} data-id="element-126" data-mp="33lwlexcoys4n">
                  <span className="text-lg font-bold text-brand-darker" data-id="element-127" data-mp="1n8xz9ym8y32t">{faq.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-accent" data-id="element-128" data-mp="1j5ruywip2lyz" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-accent" data-id="element-129" data-mp="3uu6fu3oyegfs" />}
                </button>
                <AnimatePresence initial={false} data-id="element-130" data-mp="2puf7loh4hqw">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-131" data-mp="7p73mauztwvl">
                      <p className="px-6 pb-6 leading-relaxed text-brand-darker/75" data-id="element-132" data-mp="hh4h5o9h50xh">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}